import React from "react";
import { Switch, Route } from "react-router-dom";
import { default as App } from "./App";
import { default as Layout } from "./Layout";
import { RouteUrls } from "../configs/routeUrls";
import SurveyCardPreviewContainerBO from "./projects/Survey/SurveyCardPreviewContainerBO";
import ProbeCardPreviewContainerBO from "./projects/Probe/ProbeCardPreviewContainerBO";
import ConsultationCardPreviewContainerBO from "./projects/Consultation/ConsultationCardPreviewContainerBO";
import BudgetCardPreviewContainerBO from "./projects/Budget/BudgetCardPreviewContainerBO";
import NotFound from "./NotFound";

export const Home = () => (
  <Switch>
    <Route
      exact
      path={`${RouteUrls.Survey.preview}/:id/:clientId`}
      component={SurveyCardPreviewContainerBO}
    />
    <Route
      exact
      path={`${RouteUrls.Probe.preview}/:id/:clientId`}
      component={ProbeCardPreviewContainerBO}
    />
    <Route
      exact
      path={`${RouteUrls.Consultation.preview}/:id/:clientId`}
      component={ConsultationCardPreviewContainerBO}
    />
    <Route
      exact
      path={`${RouteUrls.Budget.vote.preview}/:clientId`}
      component={BudgetCardPreviewContainerBO}
    />
    <Route exact path={RouteUrls.App.notFound} component={NotFound} />
    <App path={RouteUrls.App.main} component={Layout} />
  </Switch>
);
